import { Check, ChevronRight } from 'lucide-react';
import { formatMoney, TRANSFER_SHEET_PRICE_CENTS } from '../domain/pricing';
import type { ProductConfig } from '../domain/types';
import { getDefaultProductColour } from '../products';
import { GarmentMockup } from './GarmentMockup';

export function ProductStep({
  products,
  selected,
  onSelect,
}: {
  products: ProductConfig[];
  selected: ProductConfig;
  onSelect: (product: ProductConfig) => void;
}) {
  return (
    <section className="step-content product-step">
      <div className="content-heading">
        <div>
          <p className="eyebrow">1 / 5 · Produkt</p>
          <h2>Čo ideme vytvoriť?</h2>
        </div>
        <p>Vyberte základný typ oblečenia. Všetky parametre môžete neskôr zmeniť.</p>
      </div>
      <div className="product-grid">
        {products.map((product, index) => {
          const colour = getDefaultProductColour(product).hex;
          const active = selected.id === product.id;
          return (
            <button
              key={product.id}
              type="button"
              className={`product-card ${active ? 'selected' : ''}`}
              onClick={() => onSelect(product)}
            >
              <span className="product-selected">
                {active ? <Check size={18} /> : <ChevronRight size={18} />}
              </span>
              <div className="product-image">
                <GarmentMockup product={product} colour={colour} priority={index === 0} />
              </div>
              <div className="product-card-info">
                <p>
                  {product.garmentType === 't-shirt'
                    ? 'Krátky rukáv'
                    : product.garmentType === 'hoodie'
                      ? 'S kapucňou'
                      : 'Dlhý rukáv'}
                </p>
                <h3>{product.name}</h3>
                <span>
                  od{' '}
                  {formatMoney(
                    product.basePriceCents + TRANSFER_SHEET_PRICE_CENTS,
                    product.currency,
                  )}
                </span>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}
